import { ChangeDetectionStrategy, Component } from '@angular/core';

import { SandboxMobileService } from '../../services';

@Component({
  selector: 'lms-approval-sandbox-wrapper',
  templateUrl: './sandbox-wrapper.component.html',
  styleUrls: ['./sandbox-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SandboxWrapperComponent {
  readonly isMobile$ = this.sandboxMobileService.isMobileMode$;

  constructor(private sandboxMobileService: SandboxMobileService) {}
}
